import React from 'react';

import { MOBILE_BREAK_POINT } from 'app/constants';
import useIsMobile from 'hooks/use-is-mobile';
import Title from 'pages/Landings/components/Title';

import EstimationItem from './components/EstimationItem';
import useStyles from './styles';

interface Props {
    className?: string;
}

const PriceEstimation: React.FC<Props> = ({ className }) => {
    const { classes } = useStyles();
    const isMobile = useIsMobile(MOBILE_BREAK_POINT);
    return (
        <div className={className}>
            <Title variant="h2" align="left" className={classes.title}>
                {'Estimate your price'}
            </Title>
            <p className={classes.subtitle}>{'Plan your consumption with our API credits table'}</p>
            <div className={classes.container}>
                {isMobile ? null : (
                    <EstimationItem
                        title={'API data type'}
                        description={'Description'}
                        credits={'API credits'}
                        classes={{ item: classes.header }}
                    />
                )}
                <EstimationItem
                    title={'Search database'}
                    description={'Search database by vulnerability ID or keyword'}
                    credits={2}
                />
                <EstimationItem
                    title={'Audit Linux hosts'}
                    description={'Audit Linux hosts for vulnerabilities (RPM/DEB based)'}
                    credits={2}
                />
                <EstimationItem
                    title={'Audit Windows hosts using Registry'}
                    description={'Audit Windows host using information in the Registry'}
                    credits={2}
                />
                <EstimationItem
                    title={'Audit Windows hosts via installed KB'}
                    description={'Audit Windows host via installed KB'}
                    credits={3}
                />
                <EstimationItem
                    title={'Get vulnerabilities by CPE'}
                    description={'Get vulnerabilities by Common Platform Enumeration (CPE)'}
                    credits={3}
                />
                <EstimationItem
                    title={'Get vulnerabilities by software name/version'}
                    description={'Get vulnerabilities by package or software name and version'}
                    credits={3}
                />
                <EstimationItem title={'Get IoC data'} description={'Get Indication of Compromise data'} credits={1} />
                <EstimationItem
                    title={'Export data collection'}
                    description={'Download up-to-date Vulners data collection'}
                    credits={100}
                />
                <EstimationItem
                    title={'Perimeter Scanner (10 hosts, basic)'}
                    description={'Use Perimeter Scanner to scan a basic set of ports on 10 hosts'}
                    credits={1}
                />
                <EstimationItem
                    title={'Perimeter Scanner (10 hosts, extended)'}
                    description={'Use Perimeter Scanner to scan an extended set of ports on 10 hosts'}
                    credits={2}
                    classes={{ root: classes.borderless }}
                />
            </div>
        </div>
    );
};

export default PriceEstimation;
